import { useEffect, useRef } from "react";
import { useI18n } from "../i18n/I18nProvider";

/**
 * Frame 0:1138: 160 mobile and 196 desktop, ring 124 and 152, track #F0ECFC and arc #7C5CFF.
 * The frame still carries the success message and a back-home button; image 2 drops both, so the
 * page shows the spinner and the heading only.
 */
export function SubmittingView() {
  const { copy } = useI18n();
  const heading = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    heading.current?.focus();
  }, []);

  return (
    <div
      role="status"
      aria-live="polite"
      className="flex flex-1 flex-col items-center justify-center px-6 py-16 text-center"
    >
      <svg
        aria-hidden="true"
        className="animate-spinner h-40 w-40 lg:h-[196px] lg:w-[196px]"
        viewBox="0 0 160 160"
        fill="none"
      >
        <circle cx="80" cy="80" r="62" stroke="#F0ECFC" strokeWidth="9.8" />
        <path
          d="M80 18a62 62 0 0 1 62 62"
          stroke="#7C5CFF"
          strokeWidth="9.8"
          strokeLinecap="round"
        />
      </svg>
      <h1
        ref={heading}
        tabIndex={-1}
        className="mt-6 text-[24px] font-bold leading-tight text-navy outline-none lg:mt-7 lg:text-[32px]"
      >
        {copy.form.submitting}
      </h1>
    </div>
  );
}
